import {
  TRIAL_PACK,
  dayChargeCents,
  planPrice,
  type BillingInterval,
  type PlanKey,
} from '@str/shared';
import { money } from './format';

/**
 * The signup consent line. The $5 trial pack is credited once, on the first invoice, so the
 * recurring price is always the plan's own; the reduced figure is named as the first period only.
 * The pack's credit count is stated once, here (R4).
 */
export function trialTerms(plan: PlanKey, interval: BillingInterval, trialEnd: string): string {
  const pack = money(TRIAL_PACK.priceCents);
  const price = money(planPrice(plan, interval).totalCents);
  const first = money(dayChargeCents(plan, interval));
  return `${pack} today for ${TRIAL_PACK.credits} credits, enough for your first post and Reel · your first ${interval} is ${first} (${price} less today's ${pack}) on ${trialEnd} · then ${price} a ${interval} · cancel anytime`;
}
